module.exports = __webpack_public_path__ + "static/media/mini-arrow.a88c12ae.svg";